export const visit = (vm, at) => {
vm(require("foundations-components/lang/uk.lyaml"));
at({ "uk": { "placeholder": "\u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0447 \u043C\u0456\u0441\u0446\u044F" } });
};